import { css } from '@microsoft/fast-element';

export const MoreInfoIconStyles = css`
    .more-info {
        padding: 0px 4px 0px 8px;
    }

    .more-info zero-icon:hover {
        color: var(--white);
    }
`;
